import { createSlice } from "@reduxjs/toolkit";

export const estimateFieldsNeedToRefreshIntialState = {
  takeoffs: [],
  measurements: false,
};

const estimateListSlice = createSlice({
  name: "estimateList",
  initialState: [],
  reducers: {
    getEstimateList: (_state, action) => action.payload,
    emptyEstimateList: () => [],
  },
});

const estimateAdditionalCostSlice = createSlice({
  name: "estimateAdditionalCost",
  initialState: [],
  reducers: {
    setAdditionalCost: (_state, action) => action.payload,
  },
});

const additionalCostTotalSlice = createSlice({
  name: "additionalCostTotal",
  initialState: 0,
  reducers: {
    setEstimateAdditionalCostTotal: (_state, action) => action.payload,
  },
});

const dateVersionSlice = createSlice({
  name: "dateVersion",
  initialState: [],
  reducers: {
    getEstimateDateversion: (_state, action) => action.payload,
  },
});

const estimateDataSlice = createSlice({
  name: "estimateData",
  initialState: {},
  reducers: {
    setEstimateData: (_state, action) => action.payload,
  },
});

const estimateFieldsNeedToRefreshSlice = createSlice({
  name: "estimateFieldsNeedToRefresh",
  initialState: estimateFieldsNeedToRefreshIntialState,
  reducers: {
    setEstimateFieldsNeedtoRefresh: (_state, action) => action.payload,
  },
});

export const { getEstimateList, emptyEstimateList } = estimateListSlice.actions;
export const { setAdditionalCost } = estimateAdditionalCostSlice.actions;
export const { setEstimateAdditionalCostTotal } = additionalCostTotalSlice.actions;
export const { getEstimateDateversion } = dateVersionSlice.actions;
export const { setEstimateData } = estimateDataSlice.actions;
export const { setEstimateFieldsNeedtoRefresh } = estimateFieldsNeedToRefreshSlice.actions;

export const estimateList = estimateListSlice.reducer;
export const getEstimateAdditionalCost = estimateAdditionalCostSlice.reducer;
export const additionalCostTotal = additionalCostTotalSlice.reducer;
export const getDateVersion = dateVersionSlice.reducer;
export const estimateData = estimateDataSlice.reducer;
export const estimateFieldsNeedToRefresh = estimateFieldsNeedToRefreshSlice.reducer;

export default {
  estimateList,
  getEstimateAdditionalCost,
  additionalCostTotal,
  getDateVersion,
  estimateData,
  estimateFieldsNeedToRefresh,
};
